/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MedicalSystemBeamProduction = {
    Linac: 'Linac',
    Co60: 'Co_60'
} as const;
export type MedicalSystemBeamProduction = typeof MedicalSystemBeamProduction[keyof typeof MedicalSystemBeamProduction];


export function MedicalSystemBeamProductionFromJSON(json: any): MedicalSystemBeamProduction {
    return MedicalSystemBeamProductionFromJSONTyped(json, false);
}

export function MedicalSystemBeamProductionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalSystemBeamProduction {
    return json as MedicalSystemBeamProduction;
}

export function MedicalSystemBeamProductionToJSON(value?: MedicalSystemBeamProduction | null): any {
    return value as any;
}

/**
 * Check if a given object implements the MedicalSystemBeamProduction interface.
 */
 export function instanceOfMedicalSystemBeamProduction(value: any): value is MedicalSystemBeamProduction {
    return Object.values(MedicalSystemBeamProduction).includes(value)
}

